// Vanilla counterparts of the non-plugin parts of main-script.js.
// The Owl Carousel and Isotope features remain in assets/js/main-script.js
// because those libraries depend on jQuery.

const SCROLL_OFFSET = 220;
const ACTIVE_OFFSET = 222;

function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
}

function onScroll() {
    const scrollPos = getScrollTop() + ACTIVE_OFFSET;
    const links = document.querySelectorAll('.sidenav a');

    links.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#' || href.length < 2) {
            return;
        }

        const refElement = document.querySelector(href);
        if (!refElement) {
            return;
        }

        const top = refElement.offsetTop;
        const height = refElement.offsetHeight;

        if (top <= scrollPos && top + height > scrollPos) {
            document
                .querySelectorAll('.sidenav ul li a')
                .forEach((a) => a.classList.remove('active'));
            link.classList.add('active');
        } else {
            link.classList.remove('active');
        }
    });
}

function sidenavPos() {
    const sideNav = document.querySelector('.sidenav');
    const header = document.querySelector('.header');
    if (!sideNav || !header) {
        return;
    }

    const headerHeight = header.offsetHeight;
    const topPos = getScrollTop();

    if (headerHeight < topPos) {
        sideNav.classList.add('scrolling');
    } else {
        sideNav.classList.remove('scrolling');
    }
}

function smoothScroll() {
    if (!document.body.classList.contains('single-project')) {
        return;
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
            const href = link.getAttribute('href');
            if (!href || href === '#') {
                return;
            }

            const target = document.querySelector(href);
            if (!target) {
                return;
            }

            event.preventDefault();
            const top =
                target.getBoundingClientRect().top + getScrollTop() - SCROLL_OFFSET;

            window.scrollTo({ top, behavior: 'smooth' });
        });
    });
}

function wordChanger() {
    const el = document.getElementById('word-change');
    if (!el) {
        return;
    }

    const words = ['KIJKEN', 'LEZEN', 'LUISTEREN', 'HOREN', 'VOELEN'];
    const fadeDuration = 400;
    let count = 0;

    el.style.transition = `opacity ${fadeDuration}ms`;

    setInterval(() => {
        count += 1;
        el.style.opacity = '0';

        setTimeout(() => {
            el.textContent = words[count % words.length];
            el.style.opacity = '1';
        }, fadeDuration);
    }, 2000);
}

function bindMenuHolder() {
    const holders = document.querySelectorAll(
        '.single-project .menu-holder, .single-processen .menu-holder'
    );

    holders.forEach((holder) => {
        holder.addEventListener('click', () => {
            holder.classList.toggle('active');
        });
    });
}

function bindHamburger() {
    const navIcon = document.getElementById('nav-icon3');
    if (!navIcon) {
        return;
    }

    navIcon.addEventListener('click', () => {
        document.body.classList.toggle('mobile-nav-open');

        document
            .querySelectorAll(
                '.single-project .menu-holder, .single-processen .menu-holder'
            )
            .forEach((el) => el.classList.toggle('active'));

        document
            .querySelectorAll('.single-project #menubtn, .single-processen #menubtn')
            .forEach((el) => {
                el.style.display = 'none';
            });
    });
}

function init() {
    document.addEventListener('scroll', sidenavPos);
    document.addEventListener('scroll', onScroll);

    smoothScroll();
    wordChanger();
    bindMenuHolder();
    bindHamburger();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
